import { Emoji } from './Emoji'

export const BigEmoji = ({ contents }: { contents: any[] }) => {
    return (
        <div>
            {contents.map((content, index) => (
                <Emoji big key={index} emoji={content} />
            ))}
        </div>
    )
}
